export default __webpack_public_path__ + "static/media/home-startup-about-bg.482be546.jpg";